import React from 'react';
import { Typography } from '@material-ui/core';

import Sante24Hero from '../../../../../../../images/test-assignment-sante24-hero-de.png';

const DE = () => (
  <>
    <img
      src={Sante24Hero}
      alt="Order your assigned test"
      className="sidebar__image"
    />
    <div className="sidebar__main-content">
      <Typography variant="body2">
        <br />
        <br />
        Dir wurde von <b>santé24</b> ein Labortest von zu Hause zugewiesen.
        <br />
        <br />
        Bitte geh wie folgt vor:
        <br />
        <br />
        <b>1. Test bestellen</b>
        <br />
        Klicke auf den &quot;Bestellen&quot; Knopf am Ende dieser Email und
        folge den Anweisungen um den Bestellprozess abzuschliessen.
        <br />
        <br />
        <b>Bitte beachten:</b> Beim Check-out werden dir CHF 33.00 für Versand
        und Materialien berechnet. Dabei handelt sich um eine
        Selbstzahler-Leistung. Eine Rückerstattung durch die Grundversicherung
        ist nicht möglich. Die Analysekosten werden direkt deiner
        Grundversicherung in Rechnung gestellt. Sollte die Franchise noch nicht
        aufgebraucht sein, wird dir die Grundversicherung entsprechende Kosten
        in Rechnung stellen.
        <br />
        <br />
        <b>2. Bequem zuhause deinen Test durchführen</b>
        <br />
        1-2 Werktage nach der Bestellung erhälst du dein Testkit in einem
        diskreten Umschlag per Post nach Hause geliefert. Das Testkit enthält
        einen Aktivierungscode sowie alle Materialien und leicht verständliche
        Anweisungen zur Entnahme deiner Probe. Anschliessend verpackst du deine
        Probe in der mitgelieferten Rücksendebox und wirfst sie in einen
        beliebigen Briefkasten der Schweizer Post.
        <br />
        <br />
        <b>3. Ergebnisse erhalten</b>
        <br />
        Deine Probe wird von Medisyn, einem führenden Schweizer
        Labordienstleister, analysiert. Sobald deine Ergebnisse vorliegen,
        erhältst du einen Anruf von santé24, um sie zu besprechen. Nach dem
        Anruf werden dir die Ergebnisse online zur Verfügung gestellt.
      </Typography>
      <button type="button" className="sidebar__button">
        Zugewiesenen Test bestellen
      </button>
      <Typography variant="body2">
        Solltest du Fragen haben, kannst du uns jederzeit unter
        service@yourself.health kontaktieren!
      </Typography>
    </div>
    <div className="sidebar__footer">
      <Typography variant="body2">
        Health Yourself
        <br />
        <br />
        Lerchenfeldstrasse 3, 9014 St. Gallen, Switzerland
        <br />
        <br />
        Du möchtest diese E-Mails nicht mehr erhalten? Melde dich ab
        <br />
        <br />© 2025 Health Yourself
      </Typography>
    </div>
  </>
);

export default DE;
